import { createContext, useContext } from 'react';

import { isEmpty } from 'lodash';

import { IContractItem } from 'modules/schedules/domain/entities';

export interface IScheduleAreasContext {
  selectedAreas: IContractItem[];
  toggleArea: (area: IContractItem) => void;
  selectAreas: (areas: IContractItem[]) => void;
}

export const ScheduleAreasContext = createContext({} as IScheduleAreasContext);

export const useScheduleAreas = () => {
  const context = useContext(ScheduleAreasContext);

  if (isEmpty(context)) {
    throw new Error(
      'useScheduleAreas should be called within a ScheduleAreasContext',
    );
  }

  return context;
};
